import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EvacuationStatut } from 'src/api/models';

@Component({
  selector: 'app-evacuation-status',
  templateUrl: './evacuation-status.component.html',
  styleUrls: ['./evacuation-status.component.css']
})
export class EvacuationStatusComponent implements OnInit {

  @Input('status') public status: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetStatutEvacuation(s: EvacuationStatut) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Evacuations.Statut.' + EvacuationStatut[s]);
    }
  } 
}
